const vocabData = {
  "Essential Greetings": [
    { word: "안녕하세요", roman: "annyeonghaseyo", meaning: "hello" },
    { word: "안녕히 가세요", roman: "annyeonghi gaseyo", meaning: "goodbye (they leave)" },
    { word: "안녕히 계세요", roman: "annyeonghi gyeseyo", meaning: "goodbye (you leave)" },
    { word: "감사합니다", roman: "gamsahamnida", meaning: "thank you" },
    { word: "죄송합니다", roman: "joesonghamnida", meaning: "sorry" },
    { word: "처음 뵙겠습니다", roman: "cheoeum boepgetsseumnida", meaning: "nice to meet you" },
    { word: "잘 지내세요?", roman: "jal jinaeseyo?", meaning: "how are you?" },
    { word: "네", roman: "ne", meaning: "yes" },
    { word: "아니요", roman: "aniyo", meaning: "no" },
    { word: "좋은 아침입니다", roman: "joeun achimimnida", meaning: "good morning" },
    { word: "잘 자요", roman: "jal jayo", meaning: "good night" },
    { word: "어서 오세요", roman: "eoseo oseyo", meaning: "welcome" }
  ],
  "Numbers & Counting": [
    { word: "하나", roman: "hana", meaning: "one" },
    { word: "둘", roman: "dul", meaning: "two" },
    { word: "셋", roman: "set", meaning: "three" },
    { word: "넷", roman: "net", meaning: "four" },
    { word: "다섯", roman: "daseot", meaning: "five" },
    { word: "여섯", roman: "yeoseot", meaning: "six" },
    { word: "일곱", roman: "ilgop", meaning: "seven" },
    { word: "여덟", roman: "yeodeol", meaning: "eight" },
    { word: "아홉", roman: "ahop", meaning: "nine" },
    { word: "열", roman: "yeol", meaning: "ten" },
    { word: "스무", roman: "seumu", meaning: "twenty" },
    { word: "서른", roman: "seoreun", meaning: "thirty" },
    { word: "마흔", roman: "maheun", meaning: "forty" },
    { word: "쉰", roman: "swin", meaning: "fifty" },
    { word: "백", roman: "baek", meaning: "hundred" }
  ],
  "Food & Drinks": [
    { word: "밥", roman: "bap", meaning: "rice/meal" },
    { word: "김치", roman: "gimchi", meaning: "kimchi" },
    { word: "물", roman: "mul", meaning: "water" },
    { word: "사과", roman: "sagwa", meaning: "apple" },
    { word: "빵", roman: "ppang", meaning: "bread" },
    { word: "우유", roman: "uyu", meaning: "milk" },
    { word: "계란", roman: "gyeran", meaning: "egg" },
    { word: "고기", roman: "gogi", meaning: "meat" },
    { word: "국수", roman: "guksu", meaning: "noodles" },
    { word: "커피", roman: "keopi", meaning: "coffee" },
    { word: "주스", roman: "juseu", meaning: "juice" },
    { word: "차", roman: "cha", meaning: "tea" },
    { word: "포도", roman: "podo", meaning: "grape" },
    { word: "바나나", roman: "banana", meaning: "banana" },
    { word: "수박", roman: "subak", meaning: "watermelon" }
  ],
  "Family & People": [
    { word: "가족", roman: "gajok", meaning: "family" },
    { word: "아버지", roman: "abeoji", meaning: "father" },
    { word: "어머니", roman: "eomeoni", meaning: "mother" },
    { word: "형", roman: "hyeong", meaning: "older brother (male)" },
    { word: "누나", roman: "nuna", meaning: "older sister (male)" },
    { word: "동생", roman: "dongsaeng", meaning: "younger sibling" },
    { word: "할아버지", roman: "harabeoji", meaning: "grandfather" },
    { word: "할머니", roman: "halmeoni", meaning: "grandmother" },
    { word: "친구", roman: "chingu", meaning: "friend" },
    { word: "선생님", roman: "seonsaengnim", meaning: "teacher" },
    { word: "학생", roman: "haksaeng", meaning: "student" },
    { word: "의사", roman: "uisa", meaning: "doctor" },
    { word: "경찰", roman: "gyeongchal", meaning: "police officer" },
    { word: "요리사", roman: "yorisa", meaning: "chef" },
    { word: "운전사", roman: "unjeonsa", meaning: "driver" }
  ],
  "Colors": [
    { word: "빨간색", roman: "ppalgansaek", meaning: "red" },
    { word: "파란색", roman: "paransaek", meaning: "blue" },
    { word: "노란색", roman: "noransaek", meaning: "yellow" },
    { word: "초록색", roman: "choroksaek", meaning: "green" },
    { word: "보라색", roman: "borasaek", meaning: "purple" },
    { word: "주황색", roman: "juhwangsaek", meaning: "orange" },
    { word: "검은색", roman: "geomeunsaek", meaning: "black" },
    { word: "흰색", roman: "huinsaek", meaning: "white" },
    { word: "회색", roman: "hoesaek", meaning: "gray" },
    { word: "갈색", roman: "galsaek", meaning: "brown" },
    { word: "분홍색", roman: "bunhongsaek", meaning: "pink" },
    { word: "하늘색", roman: "haneulsaek", meaning: "sky blue" },
    { word: "금색", roman: "geumsaek", meaning: "gold" },
    { word: "은색", roman: "eunsaek", meaning: "silver" },
    { word: "무지개", roman: "mujigae", meaning: "rainbow" }
  ],
  "Animals": [
    { word: "개", roman: "gae", meaning: "dog" },
    { word: "고양이", roman: "goyangi", meaning: "cat" },
    { word: "말", roman: "mal", meaning: "horse" },
    { word: "돼지", roman: "dwaeji", meaning: "pig" },
    { word: "소", roman: "so", meaning: "cow" },
    { word: "양", roman: "yang", meaning: "sheep" },
    { word: "닭", roman: "dak", meaning: "chicken" },
    { word: "쥐", roman: "jwi", meaning: "mouse" },
    { word: "토끼", roman: "tokki", meaning: "rabbit" },
    { word: "곰", roman: "gom", meaning: "bear" },
    { word: "호랑이", roman: "horangi", meaning: "tiger" },
    { word: "사자", roman: "saja", meaning: "lion" },
    { word: "코끼리", roman: "kokkiri", meaning: "elephant" },
    { word: "원숭이", roman: "wonsungi", meaning: "monkey" },
    { word: "물고기", roman: "mulgogi", meaning: "fish" }
  ],
  "Household Items": [
    { word: "의자", roman: "uija", meaning: "chair" },
    { word: "탁자", roman: "takja", meaning: "table" },
    { word: "침대", roman: "chimdae", meaning: "bed" },
    { word: "냉장고", roman: "naengjanggo", meaning: "refrigerator" },
    { word: "문", roman: "mun", meaning: "door" },
    { word: "창문", roman: "changmun", meaning: "window" },
    { word: "텔레비전", roman: "tellebijeon", meaning: "television" },
    { word: "에어컨", roman: "eeokeon", meaning: "air conditioner" },
    { word: "전자레인지", roman: "jeonjareinji", meaning: "microwave" },
    { word: "세탁기", roman: "setakgi", meaning: "washing machine" },
    { word: "청소기", roman: "cheongsogi", meaning: "vacuum cleaner" },
    { word: "책", roman: "chaek", meaning: "book" },
    { word: "옷장", roman: "otjang", meaning: "closet" },
    { word: "시계", roman: "sigye", meaning: "clock" },
    { word: "거울", roman: "geoul", meaning: "mirror" }
  ],
  "Conversational": [
    { word: "이름", roman: "ireum", meaning: "name" },
    { word: "어디", roman: "eodi", meaning: "where" },
    { word: "무엇", roman: "mueot", meaning: "what" },
    { word: "왜", roman: "wae", meaning: "why" },
    { word: "어떻게", roman: "eotteoke", meaning: "how" },
    { word: "지금", roman: "jigeum", meaning: "now" },
    { word: "오늘", roman: "oneul", meaning: "today" },
    { word: "내일", roman: "naeil", meaning: "tomorrow" },
    { word: "괜찮아요", roman: "gwaenchanayo", meaning: "it's okay" },
    { word: "알겠습니다", roman: "algetsseumnida", meaning: "I understand" },
    { word: "모르겠어요", roman: "moreugesseoyo", meaning: "I don't understand" },
    { word: "도와주세요", roman: "dowajuseyo", meaning: "please help me" },
    { word: "얼마예요?", roman: "eolmayeyo?", meaning: "how much is it?" },
    { word: "화장실", roman: "hwajangsil", meaning: "bathroom" },
    { word: "전화번호", roman: "jeonhwabeonho", meaning: "phone number" }
  ],
  "Time & Dates": [
    { word: "시간", roman: "sigan", meaning: "time" },
    { word: "분", roman: "bun", meaning: "minute" },
    { word: "초", roman: "cho", meaning: "second" },
    { word: "시", roman: "si", meaning: "hour" },
    { word: "월요일", roman: "woryoil", meaning: "Monday" },
    { word: "화요일", roman: "hwayoil", meaning: "Tuesday" },
    { word: "수요일", roman: "suyoil", meaning: "Wednesday" },
    { word: "목요일", roman: "mogyoil", meaning: "Thursday" },
    { word: "금요일", roman: "geumyoil", meaning: "Friday" },
    { word: "토요일", roman: "toyoil", meaning: "Saturday" },
    { word: "일요일", roman: "iryoil", meaning: "Sunday" },
    { word: "1월", roman: "irwol", meaning: "January" },
    { word: "2월", roman: "iwol", meaning: "February" },
    { word: "3월", roman: "samwol", meaning: "March" },
    { word: "4월", roman: "sawol", meaning: "April" }
  ],
  "Weather & Nature": [
    { word: "날씨", roman: "nalssi", meaning: "weather" },
    { word: "해", roman: "hae", meaning: "sun" },
    { word: "달", roman: "dal", meaning: "moon" },
    { word: "별", roman: "byeol", meaning: "star" },
    { word: "구름", roman: "gureum", meaning: "cloud" },
    { word: "비", roman: "bi", meaning: "rain" },
    { word: "눈", roman: "nun", meaning: "snow" },
    { word: "바람", roman: "baram", meaning: "wind" },
    { word: "나무", roman: "namu", meaning: "tree" },
    { word: "꽃", roman: "kkot", meaning: "flower" },
    { word: "풀", roman: "pul", meaning: "grass" },
    { word: "산", roman: "san", meaning: "mountain" },
    { word: "바다", roman: "bada", meaning: "sea" },
    { word: "강", roman: "gang", meaning: "river" },
    { word: "호수", roman: "hosu", meaning: "lake" }
  ],
  "Clothing": [
    { word: "옷", roman: "ot", meaning: "clothes" },
    { word: "셔츠", roman: "syeocheu", meaning: "shirt" },
    { word: "바지", roman: "baji", meaning: "pants" },
    { word: "치마", roman: "chima", meaning: "skirt" },
    { word: "드레스", roman: "deureseu", meaning: "dress" },
    { word: "신발", roman: "sinbal", meaning: "shoes" },
    { word: "양말", roman: "yangmal", meaning: "socks" },
    { word: "모자", roman: "moja", meaning: "hat" },
    { word: "장갑", roman: "janggap", meaning: "gloves" },
    { word: "코트", roman: "koteu", meaning: "coat" },
    { word: "재킷", roman: "jaekit", meaning: "jacket" },
    { word: "스웨터", roman: "seuweteo", meaning: "sweater" },
    { word: "티셔츠", roman: "tisyeocheu", meaning: "t-shirt" },
    { word: "청바지", roman: "cheongbaji", meaning: "jeans" },
    { word: "운동화", roman: "undonghwa", meaning: "sneakers" }
  ],
  "Transportation": [
    { word: "자동차", roman: "jadongcha", meaning: "car" },
    { word: "버스", roman: "beoseu", meaning: "bus" },
    { word: "지하철", roman: "jihacheol", meaning: "subway" },
    { word: "택시", roman: "taeksi", meaning: "taxi" },
    { word: "비행기", roman: "bihaenggi", meaning: "airplane" },
    { word: "기차", roman: "gicha", meaning: "train" },
    { word: "배", roman: "bae", meaning: "ship" },
    { word: "오토바이", roman: "otobai", meaning: "motorcycle" },
    { word: "자전거", roman: "jajeongeo", meaning: "bicycle" },
    { word: "트럭", roman: "teureok", meaning: "truck" },
    { word: "헬리콥터", roman: "helikopteo", meaning: "helicopter" },
    { word: "보트", roman: "boteu", meaning: "boat" },
    { word: "스쿠터", roman: "seukuteo", meaning: "scooter" },
    { word: "지게차", roman: "jigeecha", meaning: "forklift" },
    { word: "구급차", roman: "gugeupcha", meaning: "ambulance" }
  ],
  "School & Education": [
    { word: "학교", roman: "hakgyo", meaning: "school" },
    { word: "교실", roman: "gyosil", meaning: "classroom" },
    { word: "학생", roman: "haksaeng", meaning: "student" },
    { word: "선생님", roman: "seonsaengnim", meaning: "teacher" },
    { word: "책", roman: "chaek", meaning: "book" },
    { word: "펜", roman: "pen", meaning: "pen" },
    { word: "연필", roman: "yeonpil", meaning: "pencil" },
    { word: "지우개", roman: "jiugae", meaning: "eraser" },
    { word: "자", roman: "ja", meaning: "ruler" },
    { word: "가방", roman: "gabang", meaning: "bag" },
    { word: "칠판", roman: "chilpan", meaning: "blackboard" },
    { word: "의자", roman: "uija", meaning: "chair" },
    { word: "책상", roman: "chaeksang", meaning: "desk" },
    { word: "시험", roman: "siheom", meaning: "exam" },
    { word: "숙제", roman: "sukje", meaning: "homework" }
  ],
  "Health & Body": [
    { word: "몸", roman: "mom", meaning: "body" },
    { word: "머리", roman: "meori", meaning: "head" },
    { word: "눈", roman: "nun", meaning: "eye" },
    { word: "코", roman: "ko", meaning: "nose" },
    { word: "입", roman: "ip", meaning: "mouth" },
    { word: "귀", roman: "gwi", meaning: "ear" },
    { word: "손", roman: "son", meaning: "hand" },
    { word: "발", roman: "bal", meaning: "foot" },
    { word: "다리", roman: "dari", meaning: "leg" },
    { word: "팔", roman: "pal", meaning: "arm" },
    { word: "병원", roman: "byeongwon", meaning: "hospital" },
    { word: "의사", roman: "uisa", meaning: "doctor" },
    { word: "약", roman: "yak", meaning: "medicine" },
    { word: "아프다", roman: "apeuda", meaning: "to be sick" },
    { word: "건강하다", roman: "geonganghada", meaning: "to be healthy" }
  ],
  "Shopping & Money": [
    { word: "돈", roman: "don", meaning: "money" },
    { word: "가게", roman: "gage", meaning: "store" },
    { word: "쇼핑", roman: "syoping", meaning: "shopping" },
    { word: "사다", roman: "sada", meaning: "to buy" },
    { word: "팔다", roman: "palda", meaning: "to sell" },
    { word: "가격", roman: "gagyeok", meaning: "price" },
    { word: "할인", roman: "harin", meaning: "discount" },
    { word: "영수증", roman: "yeongsujeung", meaning: "receipt" },
    { word: "카드", roman: "kadeu", meaning: "card" },
    { word: "현금", roman: "hyeongeum", meaning: "cash" },
    { word: "계산", roman: "gyesan", meaning: "calculation" },
    { word: "거스름돈", roman: "geoseureumdon", meaning: "change" },
    { word: "장바구니", roman: "jangbaguni", meaning: "shopping cart" },
    { word: "포장", roman: "pojang", meaning: "packaging" },
    { word: "배송", roman: "baesong", meaning: "delivery" }
  ],
  "Intermediate Vocabulary": [
    { word: "경험", roman: "gyeongheom", meaning: "experience" },
    { word: "기회", roman: "gihui", meaning: "opportunity" },
    { word: "목표", roman: "mokpyo", meaning: "goal" },
    { word: "계획", roman: "gyehoek", meaning: "plan" },
    { word: "문제", roman: "munje", meaning: "problem" },
    { word: "해결", roman: "haegyeol", meaning: "solution" },
    { word: "결과", roman: "gyeolgwa", meaning: "result" },
    { word: "원인", roman: "wonin", meaning: "cause" },
    { word: "효과", roman: "hyogwa", meaning: "effect" },
    { word: "방법", roman: "bangbeop", meaning: "method" },
    { word: "과정", roman: "gwajeong", meaning: "process" },
    { word: "단계", roman: "dangye", meaning: "step" },
    { word: "수준", roman: "sujun", meaning: "level" },
    { word: "품질", roman: "pumjil", meaning: "quality" },
    { word: "가치", roman: "gachi", meaning: "value" }
  ],
  "Business & Work": [
    { word: "회사", roman: "hoesa", meaning: "company" },
    { word: "직장", roman: "jikjang", meaning: "workplace" },
    { word: "직원", roman: "jigwon", meaning: "employee" },
    { word: "사장", roman: "sajang", meaning: "boss" },
    { word: "회의", roman: "hoeuui", meaning: "meeting" },
    { word: "프로젝트", roman: "peurojekteu", meaning: "project" },
    { word: "업무", roman: "eopmu", meaning: "work" },
    { word: "일정", roman: "iljeong", meaning: "schedule" },
    { word: "데드라인", roman: "dedeurain", meaning: "deadline" },
    { word: "협력", roman: "hyeomnyeok", meaning: "cooperation" },
    { word: "팀워크", roman: "timwokeu", meaning: "teamwork" },
    { word: "성과", roman: "seonggwa", meaning: "performance" },
    { word: "평가", roman: "pyeongga", meaning: "evaluation" },
    { word: "승진", roman: "seungjin", meaning: "promotion" },
    { word: "퇴직", roman: "toejik", meaning: "retirement" }
  ],
  "Technology & Internet": [
    { word: "컴퓨터", roman: "keompyuteo", meaning: "computer" },
    { word: "인터넷", roman: "inteonet", meaning: "internet" },
    { word: "웹사이트", roman: "wepeusaiteu", meaning: "website" },
    { word: "이메일", roman: "imeil", meaning: "email" },
    { word: "메시지", roman: "mesiji", meaning: "message" },
    { word: "파일", roman: "pail", meaning: "file" },
    { word: "폴더", roman: "poldeo", meaning: "folder" },
    { word: "프로그램", roman: "peurogeuraem", meaning: "program" },
    { word: "소프트웨어", roman: "sopeuteuweeo", meaning: "software" },
    { word: "하드웨어", roman: "hadeuweeo", meaning: "hardware" },
    { word: "데이터", roman: "deiteo", meaning: "data" },
    { word: "정보", roman: "jeongbo", meaning: "information" },
    { word: "보안", roman: "boan", meaning: "security" },
    { word: "비밀번호", roman: "bimilbeonho", meaning: "password" },
    { word: "계정", roman: "gyejeong", meaning: "account" }
  ]
};

export default vocabData;